import { Pickup } from '../models/pickup';
import { emptyCard } from './empty-card';
import { PickupStatusEnum } from '../enum/pickup-status.enum';

export const emptyPickup: Pickup = {
    id: null,
    reference: '',
    courierModule: '',
    courierCode: '',
    date: '',
    startTime: '',
    endTime: '',
    timestamp: null,
    shipmentIds: [],
    username: '',
    organizationId: null,
    address: emptyCard,
    parameters: [],
    allowedActions: [],
    status: PickupStatusEnum.NONE
};
